// Copyright (c) StrangeBee 2023

import { ICONS } from '@Constants/iconsApp';
import { ConfirmButtons } from '@Atoms/Buttons';
import { ColorPicker } from '@Atoms/Inputs';
import { classList } from '@Helpers/className';
import { THInput } from '@Molecules/Inputs/THInput/THInput';
import { Popover } from 'antd';
import React, { ReactElement, useState } from 'react';

import './EditableColor.scss';

interface EditableColorProps {
    readOnly?: boolean;
    onConfirm?: (value: string) => void;
    onCancel?: () => void;
    defaultColor?: string;
}

const EditableColor = ({ readOnly, onConfirm, onCancel, defaultColor = '' }: EditableColorProps): ReactElement => {
    const [editMode, setEditMode] = useState(false);
    const [value, setValue] = useState<string>(defaultColor);

    const handleCancel = (): void => {
        onCancel?.();
        setEditMode(false);
        setValue(defaultColor);
    };

    const handleConfirm = (): void => {
        onConfirm?.(value);
        setEditMode(false);
    };

    if (editMode) {
        return (
            <div className="editable-color">
                <THInput
                    value={value}
                    onChange={(e): void => setValue(e.target.value)}
                    className="editable-color__input"
                />
                <ConfirmButtons onCancel={handleCancel} onConfirm={handleConfirm}>
                    <Popover
                        key={1}
                        overlayClassName="editable-color__content"
                        content={<ColorPicker defaultColor={value} onChange={(value): void => setValue(value)} />}
                        trigger="click"
                    >
                        <ICONS.BgColorsOutlined />
                    </Popover>
                </ConfirmButtons>
            </div>
        );
    }

    return (
        <div
            className={classList('editable-color', 'form-close', { readOnly })}
            onClick={(): void => setEditMode(true)}
        >
            <span className="text-value">{value}</span>
            <ICONS.EditIcon />
        </div>
    );
};

export default EditableColor;
